import { AxiosPromise } from 'axios';

import { ISearch } from '~/components/Pagination/Search';
import { ISymbology, ISymbologyResponse } from '~/models/Symbology';

import api from './api';

const SymbologyService = {
  getSymbology(data?: ISearch): AxiosPromise<ISymbologyResponse> {
    return api.get('/symbology', { params: data });
  },

  getOneSymbology(symbologyId: string): AxiosPromise<ISymbology> {
    return api.get(`/symbology/${symbologyId}`);
  },

  createSymbology(data: ISymbology): AxiosPromise {
    return api.post('/symbology', data);
  },

  editSymbology(symbologyId: string, data: ISymbology): AxiosPromise {
    return api.put(`/symbology/${symbologyId}`, data);
  },

  deleteSymbology(symbologyId: string): AxiosPromise {
    return api.delete(`/symbology/${symbologyId}`);
  },
};

export default SymbologyService;
